<template>
  <layout-quarter bg="/images/photo-6.jpg">
    <h1 class="heading h2 t-inverse t-center">
      Are you looking to buy or rent property?
    </h1>

    <div class="button-group">
      <button-select @click.native="buying = true" :isActive="buying">Buy</button-select>
      <button-select @click.native="buying = false" :isActive="!buying">Rent</button-select>
    </div>

    <router-link class="button" to="property-type">Next</router-link>
  </layout-quarter>
</template>

<style scoped lang="scss">
  .heading {
    margin-bottom: 80px;
  }

  .button-group {
    width: 100%;
    margin-bottom: 30px;
  }
</style>

<script>
  import { remax } from '@/api';
  import LayoutQuarter from '@/layouts/Quarter';
  import ButtonSelect from '@/components/ButtonSelect'

  export default {
    name: 'BuyRent',

    components: {
      LayoutQuarter,
      ButtonSelect
    },

    computed: {
      buying: {
        get () {
          return this.$store.state.filters.buying;
        },

        set (value) {
          this.$store.commit('updateBuyingFilter', value)
        }
      }
    },

    beforeDestroy () {
      let action = this.buying ? 'getSalesPriceRanges' : 'getLettingPriceRanges';

      remax[action]()
        .then(({ data }) => this.$store.commit('updatePriceRange', data.PriceRanges))
        .catch(({ data }) => console.log(data))
    }
  };
</script>